import type {
  AggregateVariable,
  GetInteractionAggregatesReqFiltersV2Item,
  GetInteractionAggregatesReqGroupBy,
} from '@/api/generated/model';

/** Query-time proficiency tier group-by (not in OpenAPI yet). */
export type GroupByAifiProficiency = {
  kind: 'aifi_proficiency';
};

export const GROUP_BY_AIFI_PROFICIENCY: GetInteractionAggregatesReqGroupBy = {
  kind: 'aifi_proficiency',
} as unknown as GetInteractionAggregatesReqGroupBy;

/** Chart-data API breakdown for proficiency tier level mix. */
export const AIFI_PROFICIENCY_CHART_BREAKDOWN = 'aifi_proficiency';

/** Matches backend `AifiProficiencyValueConfig` (local OpenAPI). */
export type AifiProficiencyValueConfigOperator = 'below' | 'above' | 'between' | 'exactly';

export type AifiProficiencyValueConfig = {
  operator: AifiProficiencyValueConfigOperator;
  value: number;
  value_end?: number | null;
};

/** Near-promotion filter — `values` is a config object, not a string list. */
export type FilterAifiProficiency = {
  kind: 'aifi_proficiency';
  values: AifiProficiencyValueConfig;
  is_exclude?: boolean;
};

/** Points from the next-level threshold for promotion-potential counts. */
export const PROMOTION_NEAR_LEVEL_POINTS = 5;

export function buildNearPromotionAifiProficiencyFilter(
  withinPoints = PROMOTION_NEAR_LEVEL_POINTS,
): GetInteractionAggregatesReqFiltersV2Item {
  return {
    kind: 'aifi_proficiency',
    values: {
      operator: 'below',
      value: withinPoints,
    },
    is_exclude: false,
  } as unknown as GetInteractionAggregatesReqFiltersV2Item;
}

export const AIFI_DIMENSION_VARIABLE_BY_KEY: Record<string, string> = {
  task_clarity: 'aifi_task_clarity_score',
  context_provision: 'aifi_context_provision_score',
  output_specification: 'aifi_output_specification_score',
  prompt_length: 'aifi_prompt_length_score',
  conversation_efficiency: 'aifi_conversation_efficiency_score',
  constraint_specification: 'aifi_constraint_specification_score',
};

export const METHODOLOGY_AGGREGATE_VARIABLES = [
  'aifi_score',
  ...Object.values(AIFI_DIMENSION_VARIABLE_BY_KEY),
] as AggregateVariable[];

export const UPSKILLING_LEVEL_LADDER_METHODOLOGY_VARIABLES = [
  ...METHODOLOGY_AGGREGATE_VARIABLES,
  'n_users',
] as AggregateVariable[];

export const AIFI_PROFICIENCY_MIGRATION_VARIABLES = [
  'aifi_proficiency_moved_up',
  'aifi_proficiency_slipped_back',
  'aifi_proficiency_stayed',
] as AggregateVariable[];
